module.exports = __webpack_public_path__ + "static/media/solastalgia-sm-5.2f72da46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solastalgia/solastalgia-sm-5.jpg
// module id = 4438
// module chunks = 15